export default __webpack_public_path__ + "static/media/cancelled-red-cross-icon.cd16daa1.svg";